import { v4 as uuidv4 } from "https://jspm.dev/uuid";

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.selectElements();
    this.attachListeners();
  }

  // getVariantCartLogicData(){
  //   this.selects = this.querySelectorAll("select.normal-option");
  //   const productId = "gid://shopify/Product/" + this.querySelector('form[data-product-form]').dataset.productForm;
  //   const selectedOptions = [];
  //   this.selects.forEach((select) => {
  //     selectedOptions.push({
  //       "name":select.dataset.optionName,
  //       "value":select.value
  //      })
  //   });
  //   const variantData = {
  //     "id":productId,
  //     "selectedOptions": selectedOptions
  //   }
  //   return variantData;
  // }

  getAddOns() {
    this.selects = this.querySelectorAll("#custom_vars select");

    const addOns = [];
    const feltSelection = this.querySelector("input.color-swatch-option[type='radio']:checked");

    const embroideryFont = this.querySelector("#embroidery-font");
    const embroideryText = this.querySelector("#embroidery-text");

    const engraving = this.querySelector("#engraving");
    const engravingText = this.querySelector("#engraving-text");

    this.selects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];
      if (!selectedOption.dataset.variantId) return;

      addOns.push({
        variantId: selectedOption.dataset.variantId,
        addOnLabel: selectedOption.dataset.labelName,
        addOnPrice: selectedOption.dataset.addonPrice,
        addOnPriceMoney: selectedOption.dataset.addonPriceMoney,
        addOnName: select.value,
        selectedOption: selectedOption.dataset.cartlogicOptions
      });

      if (select.id === 'pool-tables-embroidery-color' && select.value) {
        addOns.push({
          addOnLabel: 'Embroidery Font',
          addOnName: embroideryFont.value
        });
        addOns.push({
          addOnLabel: 'Embroidery Text',
          addOnName: embroideryText.value
        });
      }
    });

    if (feltSelection)
      addOns.push({
        variantId: feltSelection.dataset.variantId,
        addOnLabel: feltSelection.dataset.labelName,
        addOnPrice: feltSelection.dataset.addonPrice,
        addOnPriceMoney: feltSelection.dataset.addonPriceMoney,
        addOnName: feltSelection.dataset.swatchColorName,
        addOnColorCode: feltSelection.dataset.swatchColor
    });
    if (engraving != null && engraving.value != 'No Engraving') {
        addOns.push({
            addOnLabel: 'Engraving Text',
            addOnName: engravingText.value
        });
    }

    return addOns;
  }

  // async getVariantCartLogicOptionValues(data) {
  //   const query = () => `
  //     query getProductVariantOptionsById($id: ID!, $selectedOptions:[SelectedOptionInput!]!) {
  //       product(id: $id) {
  //         variantBySelectedOptions(selectedOptions: $selectedOptions) {
  //           options: metafield(namespace: "cartlogic", key: "options") {
  //             value
  //           }
  //         }
  //       }
  //     }
  //   `;
  //   try {
  //     const res = await fetch("https://billiardscominc.myshopify.com/api/2023-01/graphql.json", {
  //       method: "POST",
  //       body: JSON.stringify({
  //         query: query(),
  //         variables: data,
  //       }),
  //       credentials: "same-origin",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-Shopify-Storefront-Access-Token": "55efefd6fafb6a16f55fd8accf352c46",
  //       },
  //     });
  //     const json = await res.json();
  //     return json.data.product.variantBySelectedOptions.options.value;
  //   } catch (err) {
  //     console.log(err);
  //     return false;
  //   }
  // }


  buildCartItems({ withInstallation = true } = {}) {
    const searchParams = new URLSearchParams(window.location.search);
    // Check for selected variant id (variable product), if none, its a simple product
    //const variantId = searchParams.has('variant') ? searchParams.get('variant') : product.variants[0].id;
    //VARIENT SELECTION
    const variantSelectionElement = document.querySelector('variant-selection.variant-selection');
    //GET VARIANT VALUE
    const variantValue = variantSelectionElement.getAttribute('variant');
    //CHECK SERACH PARAMS FOR VARIANT ID IF NOT USE VARIANT VALUE FROM VARIANT SELECTION
    const variantId = searchParams.has('variant') ? searchParams.get('variant') : variantValue;

    const addOns = this.getAddOns();
    const items = [];
    const lineItemProperties = { removalIds: [], _addOnsSubTotal: 0 };
    const option_values = [];

    // const variantCartLogicOptionValues = await this.getVariantCartLogicOptionValues(this.getVariantCartLogicData());

    for (const addOn of addOns) {

      if (addOn.addOnLabel === 'Size') continue
      if (!withInstallation && addOn.addOnLabel === 'Installation') continue

      const _uniqueKey = uuidv4();
      if (+addOn.addOnPrice) {
        items.push({
          quantity: +this.quantitySelect.value,
          id: addOn.variantId,
          properties: { _uniqueKey },
        });
        lineItemProperties[
          addOn.addOnLabel
        ] = `${addOn.addOnName} + ${addOn.addOnPriceMoney}`;
        // lineItemProperties['add-on-price'] = addOn.addonPrice;
        lineItemProperties.removalIds.push(_uniqueKey)
        lineItemProperties._addOnsSubTotal += +addOn.addOnPrice;
      } else {
        lineItemProperties[addOn.addOnLabel] = addOn.addOnName;
      }
      if (addOn.addOnColorCode) lineItemProperties.colorCode = addOn.addOnColorCode
      // add the normal variant metadata
      // if (variantCartLogicOptionValues) option_values.push(variantCartLogicOptionValues)
      // add the addon product metadata
      if (addOn.selectedOption) option_values.push(addOn.selectedOption)
    }

    if(option_values) lineItemProperties.option_values = option_values;

    items.unshift({
      quantity: +this.quantitySelect.value,
      id: variantId,
      properties: lineItemProperties,
    });

    return items;
  }

  async addToCart(data) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
      });
      const json = await res.json();
      this.addToCartBanner.show({ addedProduct: json.items[0], quantity: +this.quantitySelect.value });
    } catch (err) {
      console.log(err);
    }
  }

  selectElements() {
    this.addToCartButton = this.querySelector("#add-to-cart");
    this.quantitySelect = this.querySelector("#product-quantity-select");
    this.addToCartBanner = document.querySelector("add-to-cart-banner");
    this.installationModal = document.querySelector("installation-modal");
  }

  attachListeners() {
    this.addToCartButton.addEventListener("click", (e) => {
      e.preventDefault();

      if(document.querySelector('option[data-label-name="Installation"]')) {
        this.hasInstallation = true;
      } else {
        this.hasInstallation = false;
      }

      // If product requires installation
      if (this.hasInstallation) {
        this.installationModal.open({
          onInstall: () => {
            this.installationSelect = this.querySelector(`select#pool-tables-installation`)
            this.installationSelect.selectedIndex = "1"
            this.addToCart({ items: this.buildCartItems() })
            this.installationModal.close()
          },
          onNoInstall: () => {
            this.addToCart({ items: this.buildCartItems({ withInstallation: false }) })
            this.installationModal.close()
          }
        })
      } else {
        this.addToCart({ items: this.buildCartItems() });
        this.installationModal.close()
      }
    });
  }
}

customElements.define("product-form", ProductForm);
